export default "__VITE_ASSET__CEfg1iB4__"